import { Alert, Box, Button, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import Logo from '../../assets/images/logos/logo-skycomm.png';

const ErrorOverlay = () => (
    <Box
        sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(4px)',
            gap: 3,
            px: 2,
        }}
    >
        <Box component="img" src={Logo} alt="Skycomms" sx={{ height: 48, objectFit: 'contain' }} />

        <Alert
            severity="error"
            sx={{ maxWidth: 480, width: '100%' }}
        >
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                Algo salió mal
            </Typography>
            <Typography variant="body2">
                Ocurrió un error inesperado. Puedes recargar la página para continuar — tu sesión y datos se mantendrán.
            </Typography>
        </Alert>

        <Button
            variant="contained"
            color="primary"
            startIcon={<RefreshIcon />}
            onClick={() => window.location.reload()}
        >
            Recargar página
        </Button>
    </Box>
);

export default ErrorOverlay;
